<script setup lang="ts">
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <span
    :class="
      cn(
        'absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full border-2 border-background bg-success',
        props.class
      )
    "
  />
</template>
